<template>
  <f7-page name="agente-aprendizaje" class="aa-page">
    <f7-navbar title="Agente IA · Aprendizaje de tiempos (doble control)" :back-link="$t('atras')"></f7-navbar>

    <div class="aa">
      <div class="hero">
        <span class="tag">🧠 Planificación · Agente IA (F1)</span>
        <h1>Ajustes de duración propuestos — la DT aprueba</h1>
        <div class="sub">La IA propone, la DT aprueba, el solver aplica. Primero el TPCE base por servicio; debajo, lo que cada inspector se desvía de la norma (residual).</div>
        <!-- #16 · El panel se sirve de la memoria materializada del agente. Antes esta linea
             desaparecia si no habia fecha; ahora el sello lo dice en vez de callarse.
             El sello cambia con la pestaña porque cada una trae sus datos en su propia peticion:
             el panel, el informe semanal y el Guardian (que ademas lee otra cosa, la ficha OEB).
             Cada sello sale de la respuesta que trajo lo que se esta mirando; con uno unico, un
             informe abierto despues de un recalculo salia fechado con la corrida del panel. -->
        <div class="fresh">
          <sello-datos v-if="tab === 'guardian'" estado="fecha" :fecha="guardian.fichaActualizadaEn"
                       nota="ficha OEB oficial" />
          <sello-datos v-else-if="tab === 'informe'" estado="fecha" :fecha="informeSem.calculadoEn" />
          <sello-datos v-else estado="fecha" :fecha="actualizado" />
        </div>
      </div>

      <div class="banner" v-if="flagOff">
        ⚠️ Funcionalidad <b>desactivada</b> (flag <code>planificacion.agente.enabled=false</code>). El panel muestra lo materializado; aprobar/rechazar está inhabilitado hasta activar el flag.
      </div>

      <div class="tabs">
        <button class="tab" :class="{ on: tab === 'propuestas' }" @click="tab = 'propuestas'">✅ Propuestas a aprobar</button>
        <button class="tab" :class="{ on: tab === 'informe' }" @click="irInforme()">📊 Informe de sesgos</button>
        <button class="tab" :class="{ on: tab === 'guardian' }" @click="irGuardian()">🎯 Guardián del objetivo OEB</button>
      </div>

      <!-- ============================ PESTAÑA: PROPUESTAS ============================ -->
      <div v-show="tab === 'propuestas'">
      <div class="sect">Ajustes de campo por SERVICIO (TPCE base) · vinculados a los residuales por inspector</div>
      <div class="dt-nota">🔒 Panel de <b>Dirección Técnica</b> (DTYCAL / Director / Admin). La IA propone; <b>aprobar/rechazar</b> es el acto de doble control de la DT — el solver solo aplica lo aprobado (en F1 ni eso: no lo lee aún).</div>
      <div v-if="!servicios.length" class="vacio">No hay servicios con señal accionable en la ventana.</div>

      <div v-for="fila in servicios" :key="fila.servicio.id" class="card serv">
        <div class="serv-head" :class="{ atenuado: !accionableServicio(fila.servicio) }">
          <div class="serv-id">
            <span class="scode">{{ dim(fila.servicio).servicio }}</span>
            <span class="mtag">{{ dim(fila.servicio).materia }}</span>
            <span class="estado" :class="'e-' + estadoDe(fila.servicio)">{{ estadoDe(fila.servicio) }}</span>
          </div>
          <div class="serv-metrics">
            <span class="mx">factor <b>{{ fmt(obs(fila.servicio).factorMedio) }}×</b></span>
            <span class="mx" :class="sesgoCls(obs(fila.servicio).sesgoPct)">sesgo {{ pct(obs(fila.servicio).sesgoPct) }}</span>
            <span class="mx">n {{ obs(fila.servicio).n }}</span>
            <span class="mx">{{ obs(fila.servicio).nInspectores }} insp.</span>
            <span class="mx">conf {{ fmt(obs(fila.servicio).confianza) }}</span>
            <span class="mx">dir {{ pctSimple(obs(fila.servicio).direccionConsistentePct) }}</span>
            <span class="mx">{{ obs(fila.servicio).tendencia }}</span>
          </div>
          <div class="serv-actions">
            <span v-if="estadoDe(fila.servicio) === 'PROPUESTO'" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
              <button class="btn ok" :disabled="flagOff || enviando" @click="aprobar(fila.servicio, 'servicio')">Aprobar TPCE base</button>
              <button class="btn no" :disabled="flagOff || enviando" @click="rechazar(fila.servicio)">Rechazar</button>
            </span>
            <span v-else-if="estadoDe(fila.servicio) === 'APROBADO'" class="aprobado">✓ Aprobado → {{ prop(fila.servicio) }}</span>
          </div>
        </div>

        <table class="tbl" v-if="fila.inspectoresResiduales && fila.inspectoresResiduales.length">
          <thead><tr>
            <th>Inspector (residual)</th><th>Residual</th><th>Bruto</th><th>Factor servicio</th><th>n</th><th>Conf.</th><th>Estado</th><th></th>
          </tr></thead>
          <tbody>
            <tr v-for="ins in fila.inspectoresResiduales" :key="ins.id" :class="{ prop: estadoDe(ins) === 'PROPUESTO' }">
              <td class="txt">{{ dim(ins).inspector }}</td>
              <td class="b" :class="sesgoCls((obs(ins).residual || 1) - 1)">{{ fmt(obs(ins).residual) }}×</td>
              <td>{{ fmt(obs(ins).factorMedio) }}×</td>
              <td>{{ fmt(obs(ins).factorServicio) }}×</td>
              <td>{{ obs(ins).n }}</td>
              <td>{{ fmt(obs(ins).confianza) }}</td>
              <td><span class="estado" :class="'e-' + estadoDe(ins)">{{ estadoDe(ins) }}</span></td>
              <td>
                <span v-if="estadoDe(ins) === 'PROPUESTO' && !flagOff" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
                  <a class="lnk ok" :class="{ disabled: enviando }" @click="aprobar(ins, 'inspector')">Aprobar</a>
                  <a class="lnk no" :class="{ disabled: enviando }" @click="rechazar(ins)">Rechazar</a>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sect">Duración de INFORME</div>
      <div class="card informe">
        <div class="info-nota">📄 <b>Medido, sin propuestas — estimador ruidoso.</b> {{ informe.nota }}
          <span v-if="informe.medido"> ({{ informe.medido }} celdas medidas)</span></div>
      </div>

      <div class="sect" v-if="ajustes.length">Ajustes aprobados (congelados) · el solver NO los lee en F1</div>
      <div class="card" v-if="ajustes.length">
        <table class="tbl">
          <thead><tr><th>Parámetro</th><th>Valor</th><th>Versión</th><th>Nivel</th><th>Aprobado por</th><th>Fecha</th></tr></thead>
          <tbody>
            <tr v-for="a in ajustes" :key="a.id">
              <td class="txt">{{ a.parametroSolver }}</td><td class="b">{{ fmt(a.valor) }}×</td><td>v{{ a.version }}</td>
              <td>{{ a.nivel }}</td><td>{{ a.aprobadoPor }}</td><td>{{ a.fecha ? fecha(a.fecha) : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>

      <!-- ============================ PESTAÑA: INFORME DE SESGOS ============================ -->
      <div v-show="tab === 'informe'">
        <div class="sect">Informe de sesgos medidos (lectura de la memoria del agente)</div>
        <div class="dt-nota">📊 Resumen de lo que el agente ha <b>medido</b> esta ventana: los mayores sesgos por servicio y por inspector, y las recomendaciones para la DT. No escribe nada.</div>

        <div class="card">
          <div class="mini-sect">Top servicios por sesgo (TPCE base)</div>
          <table class="tbl" v-if="informeSem.topServiciosSesgo && informeSem.topServiciosSesgo.length">
            <thead><tr><th>Servicio</th><th>Materia</th><th>Factor</th><th>Sesgo</th><th>n</th><th>Insp.</th><th>Conf.</th><th>Tendencia</th><th>Estado</th></tr></thead>
            <tbody>
              <tr v-for="(s, i) in informeSem.topServiciosSesgo" :key="'ts' + i">
                <td class="txt">{{ s.servicio }}</td><td>{{ s.materia }}</td><td class="b">{{ fmt(s.factor) }}×</td>
                <td :class="sesgoCls(s.sesgoPct)">{{ pct(s.sesgoPct) }}</td><td>{{ s.n }}</td><td>{{ s.nInspectores }}</td>
                <td>{{ fmt(s.confianza) }}</td><td>{{ s.tendencia }}</td>
                <td><span class="estado" :class="'e-' + s.estado">{{ s.estado }}</span></td>
              </tr>
            </tbody>
          </table>
          <div v-else class="vacio">Sin servicios con sesgo medido.</div>
        </div>

        <div class="card">
          <div class="mini-sect">Top inspectores por residual (desviación de la norma del servicio)</div>
          <table class="tbl" v-if="informeSem.topInspectoresResidual && informeSem.topInspectoresResidual.length">
            <thead><tr><th>Inspector</th><th>Servicio</th><th>Materia</th><th>Residual</th><th>Bruto</th><th>F. servicio</th><th>n</th><th>Conf.</th><th>Estado</th></tr></thead>
            <tbody>
              <tr v-for="(r, i) in informeSem.topInspectoresResidual" :key="'ti' + i">
                <td class="txt">{{ r.inspector }}</td><td>{{ r.servicio }}</td><td>{{ r.materia }}</td>
                <td class="b" :class="sesgoCls((r.residual || 1) - 1)">{{ fmt(r.residual) }}×</td>
                <td>{{ fmt(r.factorBruto) }}×</td><td>{{ fmt(r.factorServicio) }}×</td><td>{{ r.n }}</td><td>{{ fmt(r.confianza) }}</td>
                <td><span class="estado" :class="'e-' + r.estado">{{ r.estado }}</span></td>
              </tr>
            </tbody>
          </table>
          <div v-else class="vacio">Sin inspectores con residual medido.</div>
        </div>

        <div class="card">
          <div class="mini-sect">Recomendaciones</div>
          <ul class="reco">
            <li v-for="(txt, i) in (informeSem.recomendaciones || [])" :key="'rc' + i">{{ txt }}</li>
          </ul>
          <div class="info-nota" v-if="informeSem.informeNota">📄 {{ informeSem.informeNota }}</div>
        </div>
      </div>

      <!-- ============================ PESTAÑA: GUARDIÁN OEB ============================ -->
      <div v-show="tab === 'guardian'">
        <div class="sect">Guardián del objetivo OEB · alerta a fecha (semanas completas)</div>
        <div class="dt-nota">🎯 Aviso <b>justo</b>: se compara la producción con el objetivo de las <b>semanas ya cerradas</b>, no con el objetivo de mes completo (que a mitad de mes siempre da un agujero por las semanas aún no transcurridas). El mes completo se muestra abajo como <b>proyección</b>. Lee de la ficha OEB oficial, sin recálculo.</div>

        <div v-if="guardian.disponible === false" class="vacio">{{ guardian.motivo || 'Sin ficha OEB para el periodo.' }}</div>

        <div v-else>
          <div class="card gcab">
            <div class="gcab-l">
              <div class="gper">Ficha OEB · <b>{{ guardian.mes }}/{{ guardian.anio }}</b>
                <span class="pill" v-if="guardian.mesEnCurso">mes en curso</span>
              </div>
              <div class="gsub" v-if="guardian.aFecha">
                {{ guardian.aFecha.nSemanasCompletas }} semanas cerradas · hoy {{ guardian.hoy }}<span v-if="guardian.semanaEnCurso"> · en curso: sem {{ guardian.semanaEnCurso }}</span>
              </div>
            </div>
          </div>

          <div class="gcards" v-if="guardian.aFecha">
            <div class="gc gc-af">
              <div class="gc-t">A fecha (semanas cerradas) — <b>base de la alerta</b></div>
              <div class="gc-big" :class="(guardian.aFecha.diferencia < 0) ? 'neg' : 'pos'">
                {{ guardian.aFecha.diferencia < 0 ? '−' : '+' }}{{ eur(Math.abs(guardian.aFecha.diferencia)) }}
              </div>
              <div class="gc-d">Real {{ eur(guardian.aFecha.real) }} · Objetivo {{ eur(guardian.aFecha.objetivo) }}
                <span v-if="guardian.aFecha.porcentaje != null">({{ guardian.aFecha.porcentaje }}%)</span></div>
            </div>
            <div class="gc gc-proy" v-if="guardian.proyeccionMes">
              <div class="gc-t">Proyección a cierre de mes</div>
              <div class="gc-big proy">{{ eur(guardian.proyeccionMes.faltanEurosTotal) }}</div>
              <div class="gc-d">faltarían al objetivo completo {{ eur(guardian.proyeccionMes.objetivoMensualTotal) }}
                <span v-if="guardian.proyeccionMes.porcentajeGlobal != null">({{ round(guardian.proyeccionMes.porcentajeGlobal) }}%)</span></div>
              <div class="gc-nota">{{ guardian.proyeccionMes.nota }}</div>
            </div>
          </div>

          <div class="sect2">Personas por debajo del objetivo <b>a fecha</b> ({{ guardian.nPersonasEnRiesgo || 0 }})</div>
          <div class="card">
            <table class="tbl" v-if="guardian.personasEnRiesgo && guardian.personasEnRiesgo.length">
              <thead><tr>
                <th>Persona</th><th>A fecha real</th><th>A fecha obj.</th><th>Dif. a fecha</th><th>%</th>
                <th>Proy. mes (falta)</th><th>Vac.</th><th></th>
              </tr></thead>
              <tbody>
                <tr v-for="p in guardian.personasEnRiesgo" :key="p.codigoPersonal">
                  <td class="txt">{{ p.nombre || p.codigoPersonal }} <span class="cod">{{ p.codigoPersonal }}</span></td>
                  <td>{{ eur(p.aFecha.real) }}</td>
                  <td>{{ eur(p.aFecha.objetivo) }}</td>
                  <td class="b neg">−{{ eur(p.aFecha.faltanEuros) }}</td>
                  <td>{{ p.aFecha.porcentaje != null ? p.aFecha.porcentaje + '%' : '—' }}</td>
                  <td class="proymes">−{{ eur(p.proyeccionMes.faltanEuros) }}<span class="cod"> de {{ eur(p.proyeccionMes.objetivoMensual) }}</span></td>
                  <td>{{ p.diasVacaciones ? round(p.diasVacaciones) : '—' }}</td>
                  <td><span class="estado" :class="'ec-' + (p.estadoColor || '').toLowerCase()">{{ p.estadoColor }}</span></td>
                </tr>
              </tbody>
            </table>
            <div v-else class="vacio">Nadie por debajo del objetivo a fecha. 👍</div>
          </div>

          <div class="gmail">
            <span class="gmail-nota">✉️ El aviso puede enviarse por email a las personas opt-in (doble gate: agente ON + <code>guardian.email.enabled</code>). En F1 (flag OFF) no envía.</span>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import AgenteAprendizaje from '../../js/db/AgenteAprendizaje.js';
import SelloDatos from '../../components/SelloDatos.vue';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

export default {
  components: { SelloDatos },
  data() {
    return {
      flagOff: false, actualizado: null, servicios: [], informe: {}, ajustes: [], enviando: false,
      tab: 'propuestas', informeSem: {}, informeCargado: false, guardian: {}, guardianCargado: false
    };
  },
  mounted() { this.cargar(); },
  methods: {
    irInforme() {
      this.tab = 'informe';
      if (this.informeCargado) return;
      var self = this;
      AgenteAprendizaje.informeSemanal().then(function(res) { self.informeSem = res || {}; self.informeCargado = true; }).catch(function() {});
    },
    irGuardian() {
      this.tab = 'guardian';
      if (this.guardianCargado) return;
      var self = this;
      AgenteAprendizaje.guardianOeb().then(function(res) { self.guardian = res || {}; self.guardianCargado = true; }).catch(function() {});
    },
    cargar() {
      var self = this;
      AgenteAprendizaje.estado().then(function(res) { self.flagOff = res && res.habilitado === false; }).catch(function() {});
      AgenteAprendizaje.panel().then(function(res) {
        self.servicios = (res && res.servicios) || [];
        self.informe = (res && res.informe) || {};
        // #16 · La fecha la publica ahora el panel mirando la memoria entera. La del primer
        // servicio de la lista no valia: el panel filtra filas, asi que la marca cambiaba al
        // cambiar los filtros y desaparecia cuando no quedaba ninguna propuesta que enseñar.
        self.actualizado = (res && res.calculadoEn) || null;
      });
      AgenteAprendizaje.ajustes().then(function(res) { self.ajustes = res || []; });
    },
    // helpers de acceso defensivo al MO
    dim(mo) { return (mo && mo.dimension) || {}; },
    obs(mo) { return (mo && mo.observacion) || {}; },
    estadoDe(mo) { return mo && mo.cicloVida ? mo.cicloVida.estado : '—'; },
    // Un servicio es "accionable" (header a color) si él mismo es PROPUESTO/APROBADO. Si no (APRENDIDO/
    // OBSERVADO: no se ajusta el TPCE base) su header va atenuado, aunque tenga residuales proponibles.
    accionableServicio(mo) { var e = this.estadoDe(mo); return e === 'PROPUESTO' || e === 'APROBADO'; },
    prop(mo) {
      var p = mo && mo.propuestaAjuste;
      return p ? (p.parametroSolver + ' = ' + this.fmt(p.valorPropuesto) + '×') : '';
    },
    // Manejador de fallo/timeout: como sendRequest advierte que una mutación con timeout PUDO aplicarse,
    // avisamos y RECARGAMOS el panel antes de permitir reintentar (evita una doble aprobación a ciegas).
    onError(accion, e) {
      var self = this;
      var msg = (e && (e.message || e.motivo || e.error)) || 'Error de red o tiempo de espera';
      this.$f7.dialog.alert('No se pudo completar ' + accion + '. ' + msg
        + '<br><small>Se recarga el estado actual; revísalo antes de reintentar (la operación pudo aplicarse).</small>',
        'Error', function() { self.cargar(); });
    },
    // aprobar en 3 pasos: botón → confirmación con detalle → aplica
    aprobar(mo, nivel) {
      if (this.flagOff || this.enviando) return;
      var self = this;
      var p = mo.propuestaAjuste || {};
      var d = mo.dimension || {};
      var quien = nivel === 'servicio' ? ('del servicio ' + d.servicio) : ('del inspector ' + d.inspector + ' en ' + d.servicio);
      var texto = 'Vas a congelar el ajuste ' + quien + ':<br><b>' + p.parametroSolver + ' = ' + this.fmt(p.valorPropuesto) + '×</b>'
        + '<br><small>Queda versionado y auditado en solver_ajustes_aprendidos. El solver NO lo aplica en F1.</small>';
      this.$f7.dialog.confirm(texto, 'Aprobar ajuste (doble control)', function() {
        // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `then`
        // que lo soltaba y la instancia (`keepAlive`) lo conservaría puesto en la cuenta siguiente.
        cerrojoDeLaSesion(self, 'enviando');
        AgenteAprendizaje.aprobar(mo.id).then(function(r) {
          if (r && r.ok) { self.$f7.toast.show({ text: 'Aprobado: ' + r.parametroSolver + ' v' + r.version, closeTimeout: 2500 }); }
          else { self.$f7.dialog.alert((r && r.motivo) || 'No se pudo aprobar'); }
          self.enviando = false;
          self.cargar();
        }).catch(function(e) { self.enviando = false; self.onError('la aprobación', e); });
      });
    },
    rechazar(mo) {
      if (this.flagOff || this.enviando) return;
      var self = this;
      this.$f7.dialog.prompt('Motivo del rechazo (opcional):', 'Rechazar propuesta', function(motivo) {
        cerrojoDeLaSesion(self, 'enviando');
        AgenteAprendizaje.rechazar(mo.id, motivo).then(function(r) {
          if (r && r.ok) { self.$f7.toast.show({ text: 'Rechazado', closeTimeout: 2000 }); }
          else { self.$f7.dialog.alert((r && r.motivo) || 'No se pudo rechazar'); }
          self.enviando = false;
          self.cargar();
        }).catch(function(e) { self.enviando = false; self.onError('el rechazo', e); });
      });
    },
    eur(n) { return n == null ? '—' : (Math.round(Number(n)).toLocaleString('es-ES') + ' €'); },
    round(n) { return n == null ? '—' : Math.round(Number(n)); },
    fmt(n) { return n == null ? '—' : (Math.round(Number(n) * 1000) / 1000); },
    pct(n) { return n == null ? '—' : ((n >= 0 ? '+' : '') + Math.round(Number(n) * 1000) / 10 + '%'); },
    pctSimple(n) { return n == null ? '—' : (Math.round(Number(n) * 100) + '%'); },
    sesgoCls(n) { return n == null ? '' : (Number(n) >= 0 ? 'pos' : 'neg'); },
    fecha(d) { return new Date(d).toLocaleDateString('es-ES'); }
  }
};
</script>

<style scoped>
.aa { max-width: 1160px; margin: 0 auto; padding: 14px 16px 60px; color: #0b0b0b; }
.hero { border-radius: 16px; color: #fff; background: linear-gradient(135deg, #12203f, #23407e 60%, #3f6fd0); padding: 18px 22px; margin-bottom: 12px; }
.hero .tag { font-size: 11px; background: rgba(255,255,255,.16); border: 1px solid rgba(255,255,255,.26); padding: 3px 10px; border-radius: 999px; }
.hero h1 { margin: 8px 0 2px; font-size: 20px; font-weight: 800; }
.hero .sub { opacity: .92; font-size: 13px; }
/* El sello ya trae su propia pastilla: aquí solo se le hace hueco. */
.hero .fresh { margin-top: 8px; }
.banner { background: #fff8e6; border: 1px solid #f0d98a; border-radius: 10px; padding: 9px 13px; font-size: 12.5px; margin-bottom: 12px; }
.banner code { background: #f2ecd0; padding: 1px 5px; border-radius: 4px; }
.sect { font-size: 11px; font-weight: 800; color: #6a7288; text-transform: uppercase; letter-spacing: .05em; margin: 14px 2px 8px; }
.card { background: #fcfcfb; border: 1px solid #e1e0d9; border-radius: 14px; box-shadow: 0 1px 2px rgba(11,11,11,.04); padding: 14px 16px; margin-bottom: 12px; }
.serv-head { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; justify-content: space-between; }
.serv-head.atenuado { opacity: .5; filter: grayscale(.6); }
.serv-id { display: flex; align-items: center; gap: 8px; }
.scode { font-weight: 800; font-size: 15px; }
.mtag { font-size: 10px; font-weight: 800; padding: 2px 7px; border-radius: 999px; background: #eef; color: #345; }
.estado { font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 999px; }
.e-PROPUESTO { background: #e6f1fb; color: #185FA5; } .e-APROBADO { background: #d5f5e3; color: #0B5345; }
.e-APRENDIDO { background: #eeede8; color: #52514e; } .e-OBSERVADO { background: #f3f3f0; color: #898781; } .e-DESCARTADO { background: #fbe4e4; color: #b02a2a; }
.serv-metrics { display: flex; flex-wrap: wrap; gap: 8px; font-size: 12px; color: #52514e; }
.serv-metrics .mx { background: #f4f4f1; border-radius: 6px; padding: 2px 8px; font-variant-numeric: tabular-nums; }
.serv-metrics .pos { color: #b45309; } .serv-metrics .neg { color: #0ca30c; }
.serv-actions { display: flex; gap: 8px; }
.btn { border: 0; border-radius: 8px; padding: 7px 12px; font-size: 12.5px; font-weight: 700; cursor: pointer; }
.btn.ok { background: #0B5345; color: #fff; } .btn.no { background: #f4f4f1; color: #b02a2a; }
.btn:disabled { opacity: .45; cursor: not-allowed; }
.aprobado { font-size: 12px; font-weight: 700; color: #0B5345; }
.tbl { width: 100%; border-collapse: collapse; font-size: 12.5px; margin-top: 12px; }
.tbl th { text-align: left; font-size: 10px; text-transform: uppercase; color: #898781; font-weight: 700; padding: 7px 8px; border-bottom: 1px solid #e1e0d9; }
.tbl td { padding: 8px; border-bottom: 1px solid #eeede8; font-variant-numeric: tabular-nums; }
.tbl td.txt { font-variant-numeric: normal; font-weight: 600; }
.tbl tr.prop td { background: #f5faff; }
.b { font-weight: 700; } .pos { color: #b45309; } .neg { color: #0ca30c; }
.lnk { font-weight: 700; cursor: pointer; margin-right: 10px; }
.lnk.ok { color: #0B5345; } .lnk.no { color: #b02a2a; }
.lnk.disabled { opacity: .4; pointer-events: none; }
.informe .info-nota { font-size: 13px; color: #52514e; }
.dt-nota { background: #eef4fb; border: 1px solid #cdddef; border-radius: 10px; padding: 8px 12px; font-size: 12px; color: #2a4d78; margin-bottom: 10px; }
.vacio { text-align: center; color: #898781; font-size: 12.5px; padding: 16px; }
.tabs { display: flex; gap: 6px; margin: 4px 0 6px; flex-wrap: wrap; }
.tab { border: 1px solid #e1e0d9; background: #f4f4f1; color: #52514e; border-radius: 999px; padding: 7px 14px; font-size: 12.5px; font-weight: 700; cursor: pointer; }
.tab.on { background: #23407e; color: #fff; border-color: #23407e; }
.mini-sect { font-size: 12px; font-weight: 800; color: #34405a; margin-bottom: 4px; }
.reco { margin: 4px 0 8px; padding-left: 18px; font-size: 12.5px; color: #34405a; }
.reco li { margin-bottom: 5px; }
.sect2 { font-size: 12px; font-weight: 800; color: #34405a; margin: 12px 2px 6px; }
.gcab { display: flex; justify-content: space-between; align-items: center; }
.gper { font-size: 14px; } .gsub { font-size: 11.5px; color: #898781; margin-top: 2px; }
.pill { font-size: 10px; font-weight: 800; background: #fff3d6; color: #8a6414; border-radius: 999px; padding: 2px 8px; margin-left: 6px; }
.gcards { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 6px; }
.gc { flex: 1 1 260px; border-radius: 14px; padding: 14px 16px; border: 1px solid #e1e0d9; background: #fcfcfb; }
.gc-af { border-left: 4px solid #23407e; } .gc-proy { border-left: 4px solid #cbb56b; background: #fbf9f1; }
.gc-t { font-size: 11px; font-weight: 800; text-transform: uppercase; color: #6a7288; letter-spacing: .04em; }
.gc-big { font-size: 26px; font-weight: 800; margin: 6px 0 2px; font-variant-numeric: tabular-nums; }
.gc-big.pos { color: #0B5345; } .gc-big.neg { color: #b02a2a; } .gc-big.proy { color: #8a6414; }
.gc-d { font-size: 12px; color: #52514e; } .gc-nota { font-size: 10.5px; color: #a08a4a; margin-top: 6px; font-style: italic; }
.cod { font-size: 10.5px; color: #a5a29a; font-weight: 600; }
.proymes { color: #8a6414; font-variant-numeric: tabular-nums; }
.ec-muy_malo, .ec-rojo { background: #fbe4e4; color: #b02a2a; font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 999px; }
.ec-malo, .ec-naranja { background: #fde7d6; color: #b45309; font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 999px; }
.ec-regular, .ec-amarillo { background: #fdf6d6; color: #8a6414; font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 999px; }
.ec-bueno, .ec-verde { background: #d5f5e3; color: #0B5345; font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 999px; }
.gmail { margin-top: 8px; } .gmail-nota { font-size: 11.5px; color: #898781; }
.gmail code { background: #f2f2ee; padding: 1px 5px; border-radius: 4px; }
</style>
